import { render, staticRenderFns } from "./monitoringOwnerTable.vue?vue&type=template&id=2bedf5a4&scoped=true&"
import script from "./monitoringOwnerTable.vue?vue&type=script&lang=js&"
export * from "./monitoringOwnerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bedf5a4",
  null
  
)

export default component.exports